import { DatePipe } from '@angular/common';
import { FormatNumberPipe } from '../../../../../shared/pipes/number-separator.pipe';
import { EntityPopup, PopupInfoItem } from './entity-popup.interface';

/**
 * Interface para los items del badge del pozo
 */
export interface PozoBadgeItem {
  proveedor: string;
  propietario: string;
  expediente: string;
  volumen: string;
  categoria: string;
  idChj: string;
}

/**
 * Popup para pozos.
 * Muestra datos de caudal, nivel, última lectura y un badge con información administrativa.
 */
export class PozoPopup implements EntityPopup {
  private formatNumber = new FormatNumberPipe();
  private datePipe = new DatePipe('es-ES');

  constructor(private entity: any) {}

  getBadgeText(): string {
    return '';
  }

  /**
   * Devuelve los items del badge con la información administrativa del pozo.
   */
  getBadgeItems(): PozoBadgeItem {
    const volumen =
      this.entity.volume_conceded_m3 != null
        ? `${this.formatNumber.transform(this.entity.volume_conceded_m3)} m³`
        : '-';

    return {
      proveedor: `Proveedor: ${this.entity.provider_code || '-'}`,
      propietario: `Propietario: ${this.entity.owner_name || '-'}`,
      expediente: `Nº expediente: ${this.entity.file_number || '-'}`,
      volumen: `Volumen concedido: ${volumen}`,
      categoria: `Categoría: ${this.entity.category || '-'}`,
      idChj: `ID CHJ: ${this.entity.chj_id || '-'}`,
    };
  }

  getInfoItems(): PopupInfoItem[] {
    const formattedDate = this.datePipe.transform(
      this.entity.current_datetime,
      'dd/MM/yyyy HH:mm:ss'
    );

    return [
      {
        icon: 'water',
        label: 'Caudal',
        value: this.entity.current_flow,
        unit: 'm³/h',
        date: formattedDate,
      },
      {
        icon: 'humidity_mid',
        label: 'Nivel',
        value: this.entity.current_level > 0 ? this.entity.current_level : null,
        unit: 'm',
      },
      {
        icon: 'readiness_score',
        label: 'Última lectura',
        value:
          this.entity.current_accumulated != null
            ? this.entity.current_accumulated.toFixed(2)
            : null,
        unit: 'm³',
        date: formattedDate,
      },
    ];
  }
}
